import type { MarketingComposerExample } from './marketing-page-content-types';

export function selectMarketingComposerExample(
  currentDraft: string,
  example: MarketingComposerExample
): string {
  return currentDraft === example.prompt ? '' : example.prompt;
}

export function shouldSubmitMarketingComposer(event: {
  key: string;
  shiftKey: boolean;
  isComposing: boolean;
}): boolean {
  return event.key === 'Enter' && !event.shiftKey && !event.isComposing;
}

export function hasMarketingComposerDraft(draft: string): boolean {
  return draft.trim().length > 0;
}
